"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EviscerateAbilityHandler = exports.EviscerateActorAbilityFactory = exports.EviscerateAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Bleeding_1 = require("../../core/effects/core/Bleeding");
const Registries_1 = require("../../core/state/Registries");
class EviscerateAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Eviscerate;
        this.__typeName = "Eviscerate";
    }
}
exports.EviscerateAbilityArgs = EviscerateAbilityArgs;
let EviscerateActorAbilityFactory = class EviscerateActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Eviscerate", "OneEnemies", 2);
    }
};
EviscerateActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Eviscerate")
], EviscerateActorAbilityFactory);
exports.EviscerateActorAbilityFactory = EviscerateActorAbilityFactory;
let EviscerateAbilityHandler = class EviscerateAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 80)
            ],
            onHit(sequence) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new Bleeding_1.BleedingEffectArgs("Power", 10),
                });
            }
        });
    }
};
EviscerateAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Eviscerate)
], EviscerateAbilityHandler);
exports.EviscerateAbilityHandler = EviscerateAbilityHandler;
